/**
 * Canonical list of deal constraints.
 * Use everywhere: post form, edit form, filter bar.
 */

export const DEAL_CONSTRAINTS = [
  { id: 'occupied', label: 'Occupied' },
  { id: 'assignment', label: 'Assignment' },
  { id: 'double_close', label: 'Double Close' },
  { id: 'non_refundable_emd', label: 'Non-Refundable EMD' },
  { id: 'limited_inspection', label: 'Limited Inspection' },
  { id: 'access_restrictions', label: 'Access Restrictions' },
  { id: 'title_issues_known', label: 'Title Issues Known' },
  { id: 'hoa_involved', label: 'HOA Involved' },
] as const;

export type DealConstraintId = (typeof DEAL_CONSTRAINTS)[number]['id'];

export function getDealConstraintLabel(id: string): string {
  const found = DEAL_CONSTRAINTS.find((c) => c.id === id);
  return found?.label ?? id;
}
